// extracted by mini-css-extract-plugin
export default {"noChatListWrapper":"noChatList_noChatListWrapper__ohKuD","noChatListImage":"noChatList_noChatListImage__74NZ0","noChatListText":"noChatList_noChatListText__Dz8jL"};